import { 
  integrations, 
  showGoogleStatusModal, 
  hasCheckedIntegration,
  showOAuthLoading,
  oauthStatus,
  oauthErrorMessage
} from '../state'
// selectedIntegration ve showManageModal kaldırıldı
import { integrationService } from '../../../services/integration/integration-service'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Handles OAuth response after redirection from platform
 * @param {number} id - ID of the integration
 * @param {Object} data - OAuth response data
 * @param {Function} t - Translation function passed from parent
 * @param {Object} router - Vue Router instance passed from parent
 * @param {Function} loadGoogleAccounts - Function to load Google accounts passed from parent
 */
export const handleOAuthResponse = async (id, data, t, router, loadGoogleAccounts) => {
  const integration = integrations.value.find((i) => i.id === id)
  if (!integration) return

  integration.loading = true

  try {
    const result = await integrationService.handleOAuthResponse(id, data, integrations.value)

    if (result.success) {
      // Update OAuth loading status to success
      oauthStatus.value = 'success'
      
      responseHandlerService.handleSuccess(
        t('settings.components.integrations.responseHandler.success.integrationSuccessful', 
          { integrationName: result.name })
      )

      // Sadece Google entegrasyonu için (ID=6)
      if (id === 6) {
        // selectedIntegration kaldırıldı
        showGoogleStatusModal.value = true
        
        // Google hesaplarını yükle
        await loadGoogleAccounts()
      } else {
        // Diğer entegrasyonlar için sadece loglama
        console.log('Integration connected:', integration.name)
      }
    } else if (result.isDuplicate) {
      // Duplicate hesap hatası için özel işleme
      oauthStatus.value = 'error'
      
      // Duplicate hesap özel hata gösterimi
      const errorMsg = result.emailAddress 
        ? `Bu Google hesabı (${result.emailAddress}) zaten bağlı.` 
        : 'Bu Google hesabı zaten bağlı.';
      
      oauthErrorMessage.value = errorMsg;
      
      responseHandlerService.handleError(
        null,
        errorMsg,
        'warning' // Hata değil uyarı olarak göster
      )
      
      // Mevcut hesapları göster - varsa
      if (id === 6) {
        await loadGoogleAccounts()
        // İsteğe bağlı olarak modal'ı gösterebiliriz
        showGoogleStatusModal.value = true
      }
    } else {
      // Update OAuth loading status to error
      oauthStatus.value = 'error'
      oauthErrorMessage.value = t('settings.components.integrations.responseHandler.errors.integrationError', 
        { integrationName: result.name })
        
      responseHandlerService.handleError(
        null,
        t('settings.components.integrations.responseHandler.errors.integrationError', 
          { integrationName: result.name })
      )
    }
  } catch (error) {
    // Update OAuth loading status to error
    oauthStatus.value = 'error'
    oauthErrorMessage.value = t('settings.components.integrations.responseHandler.errors.integrationError', 
      { integrationName: integration.name })
      
    responseHandlerService.handleError(
      error,
      t('settings.components.integrations.responseHandler.errors.integrationError', 
        { integrationName: integration.name })
    )
  } finally {
    setTimeout(() => {
      integration.loading = false
      
      // Hide OAuth loading after a delay
      setTimeout(() => {
        showOAuthLoading.value = false
      }, 2000)
    }, 1000)
    
    // Query parametrelerini temizle
    await router.replace({
      query: {
        ...router.currentRoute.value.query,
        integration: undefined,
        code: undefined,
        scope: undefined
      },
    })
  }
}